"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth_1 = require("common/auth");
const react_1 = __importDefault(require("react"));
const components_1 = require("utils/components");
const Footer = () => {
    const { isAdmin } = (0, auth_1.useAdminAuthentication)();
    return (react_1.default.createElement("footer", { style: {
            display: "flex",
            justifyContent: "center",
            marginBottom: "10px",
            gap: "1rem",
        } },
        react_1.default.createElement(components_1.Link, { to: "https://drecom.co.jp/privacy/", className: "text-primary", style: { fontSize: "10px", fontWeight: 500 } }, "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC"),
        react_1.default.createElement(components_1.Link, { to: "https://terms.aiand.drecom.co.jp/index.html", className: "text-primary", style: { fontSize: "10px", fontWeight: 500 } }, "\u5229\u7528\u898F\u7D04")));
};
exports.default = Footer;
